export const STANDORTE_TAB = 0;
export const MITGLIEDER_TAB = 1;
export const WARTELISTE_TAB = 2;
export const TRAINER_TAB = 3;
export const MAHNUNG_TAB = 4;

export type AdminManagementTabTypes =
  | typeof STANDORTE_TAB
  | typeof MITGLIEDER_TAB
  | typeof WARTELISTE_TAB
  | typeof TRAINER_TAB
  | typeof MAHNUNG_TAB;

export const ALL_MAHNUNG = "ALL";
export const ACTIVE_MAHNUNG = "ACTIVE";
export const COMPLETED_MAHNUNG = "COMPLETED";
export const IMPORT_MAHNUNG = "IMPORT";
export const INKASSO_MAHNUNG = "INKASSO";

export type AdminMahnungFilterTypes =
  | typeof ALL_MAHNUNG
  | typeof ACTIVE_MAHNUNG
  | typeof COMPLETED_MAHNUNG
  | typeof IMPORT_MAHNUNG
  | typeof INKASSO_MAHNUNG;
